import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import back1 from '../../images/leftImg1.png';
import back2 from '../../images/leftImg2.png';
import back3 from '../../images/back3.png';

const HomeContainer = styled.div`
  margin-bottom: 5%;
`;

const TxtBox = styled.div`
  text-align: center;
  h1 {
    font-size: calc(20px + 4vmin);
    margin-block-start: 2em;
  }
  h2 {
    font-size: calc(16px + 2vmin);
  }
`;

const DownContainer = styled.div`
  h1 {
    font-size: calc(20px + 4vmin);
    color: #00bed8;
  }
`;

const TopContents = styled.div`
  display: flex;
  justify-content: space-between;
  background-image: url(${back3});
  background-position: right top;
  background-repeat: no-repeat;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftImg = styled.div`
  width: 60%;
  position: relative;
  padding-bottom: 20%;
  
  img {
    width: 85%;
  }

  .firstBackImg {}

  .SecondBackImg {
    position: absolute;
    top: 25%;
    left: 10%;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding-bottom: 0;
  }
`;

const RightBtn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 25%;
  margin: 0 auto 3%;

  h3 {
    text-align: center;
    font-size: calc(10px + 2vmin);
  }

  button {
    padding: 10% 0;
    white-space: nowrap;
    background-color: #00bed8;
    border: none;
    border-radius: 10px;
    color: white;
    margin: 2% 0;
    cursor: pointer;
    width: 20rem;
    font-size: 16px;

    &:hover {
      background-color: #008fa1;
    }

    @media (max-width: 768px) {
      font-size: 14px;
      padding: 8px 16px;
      width: auto;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BottomContents = styled.div`
  background-image: url(${back2});
  background-position: right center;
  background-repeat: no-repeat;
  padding-top: 5%;

  h2 {
    font-size: calc(16px + 2vmin);
    margin-block-end: 0;
    margin-block-start: 0;
  }

  h3 {
    font-size: calc(10px + 2vmin);
    margin-block-start: 0.5em;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
  }

  li {
    font-size: calc(12px + 1vmin);
    margin: 1% 0;
  }
`;

const GuidContainer = styled.div`
  margin: 4% 0 10%;

  h1 {
    font-size: calc(20px + 4vmin);
    color: #00bed8;
  }

  .guideTxt {
    margin-bottom: 20px;

    .TitleTxt {
      font-size: calc(12px + 1.5vmin);
    }

    .infoTxt {
      padding-left: 2.5%;
      font-size: calc(12px + 1vmin);
    }
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;

    li {
      font-size: calc(12px + 1vmin);
      margin: 0.5% 0;
    }
  }
`;

const DownloadFont = styled.div`
  width: 100px;

  @media (max-width: 1200px) {
    width: 100px;
  }

  @media (max-width: 800px) {
    width: 100px;
  }

  @media (max-width: 600px) {
    width: 100px;
  }

  @media (max-width: 400px) {
    width: 50px;
  }
`;

const Con = styled.div`
  top: 950px;
  left: 250px;

  @media (max-width: 1200px) {
    top: 950px;
    left: 250px;
  }

  @media (max-width: 800px) {
    top: 800px;
    left: 220px;
  }

  @media (max-width: 600px) {
    top: 420px;
    left: 130px;
  }

  @media (max-width: 400px) {
    top: 405px;
    left: 115px;
  }
`;

const Button = styled.button`
  width: 250px;

  @media (max-width: 1200px) {
    width: 250px;
  }

  @media (max-width: 800px) {
    width: 200px;
  }

  @media (max-width: 600px) {
    width: 125px;
  }

  @media (max-width: 400px) {
    width: 100px;
  }
`;

export default function Home(){
    const [currentCount, setCurrentCount] = useState(0); // 현재 방문자 수를 저장할 상태
    const systemId = 'NodeMaster';

    // 당일 방문자 수를 업데이트하고 현재 카운트를 받아오는 함수
    const updateVisitorCount = async () => {
      try {
        const response = await fetch(`api/updateVisitorCount?systemId=${systemId}`, {
          method: 'GET', // GET 메소드 사용
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setCurrentCount(data.currentCount); // 응답으로 받은 현재 방문자 수를 상태로 저장
      } catch (error) {
        console.error('Error fetching visitor count:', error);
      }
    };
  
    // 컴포넌트가 마운트될 때 당일 방문자 수 업데이트 함수를 호출
    useEffect(() => {
      updateVisitorCount();
    }, []); // 빈 의존성 배열을 사용하여 컴포넌트 마운트 시에만 호출되도록 설정

    return (
        <HomeContainer>
            {/* 글자 */}
            <TxtBox>
                <h1>
                    생각을 정리하는 <br/>
                    가장 스마트한 방법
                </h1>
                <h2>떠오르는 모든 생각을 빠르고 쉽게 기록하고 관리하세요</h2>
            </TxtBox>
            {/* 다운로드 섹션 */}
            <DownContainer>
                <h1>NodeMaster</h1>
                {/* 다운로드 이미지 & 버튼 */}
                <TopContents>
                    <LeftImg>
                        <img src={back1} className='firstBackImg' alt="First Background"/>
                        <img src={back2} className='SecondBackImg' alt="Second Background"/>
                    </LeftImg>
                    <RightBtn>
                        <h3>다운로드</h3>
                        
                        {/* <a><button>[클라우드] 노드마스터 다운로드 준비중</button></a> */}
                        <a href={'files/NodeMasterLocal.msi'} download="NodeMasterLocal.msi"><Button>[로컬] 노드마스터 다운로드 V 0.01</Button></a>
                        <a href={'files/NodeMasterInstaller.msi'} download="NodeMasterInstaller.msi"><Button>[클라우드] 노드마스터 다운로드 V 0.02</Button></a>
                        <a href={'files/Guide.pdf'} download="Guide.pdf"><Button>사용자 가이드</Button></a>
                    </RightBtn>
                </TopContents>
                {/* 설명 */}
                <BottomContents>
                    <h2>데이터 정리 수집 프로그램</h2>
                    <h3>트리뷰와 웹 형태로 많은 자료를 목차형태로 볼 수 있는 정리 도구</h3>
                    <ul>
                        <li>계층구조를 통한 내용의 카테고리화</li>
                        <li>강력한 검색 기능</li>
                        <li>체크리스트 기능 지원</li>
                        <li>데이터의 안전한 저장/보호</li>
                        <li>직관적인 UI</li>
                        <li>단축키 활용으로 빠른 편집</li>
                    </ul>
                </BottomContents>
            </DownContainer>

            {/* 가이드 내용 */}
            <GuidContainer>
                <h1>Guide</h1>
                <div className='guideTxt'>
                    <p className='TitleTxt'>&#9632; 하루 일정 정리</p>
                    <p className='infoTxt'>
                        사용자가 하루 동안의 일정을 입력하고, 시간대나 카테고리 등으로<br/>
                        일정을 분류하고 관리할 수 있도록 합니다.
                    </p>
                </div>
                <div className='guideTxt'>
                    <p className='TitleTxt'>&#9632; 배운 강의 내용 정리</p>
                    <p className='infoTxt'>
                        앤츠네스트에서 제공하는 강의를 수강하고, 핵심 내용을 정리하여<br/>
                        저장하고 복습할 수 있도록 합니다.
                    </p>
                </div>
                <div className='guideTxt'>
                    <p className='TitleTxt'>&#9632; 아이디어 정리</p>
                    <p className='infoTxt'>
                        사용자가 창의적인 아이디어를 기록하고, 관리하며, 효율적으로 활용할 수 있도록 합니다.
                    </p>
                </div>
                <div className='guideTxt'>
                    <p className='TitleTxt'>&#9632; 기능</p>
                    <ul>
                        <li>사용자 인증과 권한 관리를 구현하여 개인 정보와 중요한 데이터를 보호합니다.</li>
                        <li>데이터를 클라우드에 안전하게 저장하고 백업할 수 있도록 합니다.</li>
                        <li>사용자 인터페이스(UI)를 사용하기 쉽게 직관적으로 디자인하여<br/>편리한 사용자 경험을 제공합니다.</li>
                    </ul>
                </div>
            </GuidContainer>
            visitor : {currentCount}
        </HomeContainer>
    );
}